module.exports = __webpack_public_path__ + "static/media/homedelivery.db132bf4.jpg";